/* eslint-disable max-len */
import { AllieIconProps } from '../../../components';

export const ZoomInIcon: React.FC<AllieIconProps> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path
      d="M12 12L9.58333 9.58333M6.44444 4.77778V8.11111M4.77778 6.44444H8.11111M10.8889 6.44444C10.8889 8.89904 8.89904 10.8889 6.44444 10.8889C3.98985 10.8889 2 8.89904 2 6.44444C2 3.98985 3.98985 2 6.44444 2C8.89904 2 10.8889 3.98985 10.8889 6.44444Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
